// TEMPORARY ENV CONFIG FILE
// Swap this file as needed for different environments (develop/production)
// Replace the values below with those from your .env.develop or .env.production as needed

export const envConfig = {
  FIREBASE_API_KEY: 'AIzaSyChh3AQ4HYuDSRPmEO-fhppwljAeeg_j7A',
  FIREBASE_AUTH_DOMAIN: 'omnichannel-3b80d1cf.firebaseapp.com',
  FIREBASE_DATABASE_URL: 'https://omnichannel-3b80d1cf-default-rtdb.europe-west1.firebasedatabase.app',
  FIREBASE_PROJECT_ID: 'omnichannel-3b80d1cf',
  FIREBASE_STORAGE_BUCKET: 'gcf-sources-170426517486-us-central1',
  FIREBASE_MESSAGING_SENDER_ID: '170426517486',
  FIREBASE_APP_ID: '1:170426517486:web:25482bfda1bb0f6cd130ff',
  ALLOWED_ORIGINS: 'http://localhost:8080,http://127.0.0.1:8080,https://interactive.digitalpfizer.com,https://webfiles.digitalpfizer.com',
};
